export default __webpack_public_path__ + "static/soehne-mono-web-buch-7f91d552f2b558c1d17a611ed5575dae.woff";